import { useCallback, useMemo } from 'react';
import { useScreenReaderAlert } from '@core/accessibility/screenReader/useScreenReaderAlert';
import { useContextTranslation } from '@core/i18n';
import { PlayerLayout } from '@core/player/types';
/**
 * Announce the display state of the player to screen readers
 * used when the player changes state from one to another
 */
export function usePlayerStateAnnouncement() {
    const renderScreenReaderAlert = useScreenReaderAlert();
    const { t } = useContextTranslation();
    const messages = useMemo(() => ({
        [PlayerLayout.FULLSCREEN]: t('player:Player is fullscreen'),
        [PlayerLayout.DEFAULT]: t('player:Player is inline'),
        [PlayerLayout.MINIMIZED]: t('player:Player is in Picture in Picture mode'),
    }), [t]);
    return useCallback((displayState) => {
        renderScreenReaderAlert(messages[displayState]);
    }, [renderScreenReaderAlert, messages]);
}
